import type { AdminAiScanFeatureGroupProps } from "../../models/admin-ai-scans.models";
import { adminAiScansStyles } from "../../styles/admin-ai-scans.styles";
import {
  getAdminAiScanFindingSeverity,
  getAdminAiScanSeverityCounts,
  getAdminAiScanText,
} from "../../utils/admin-ai-scans.utils";
import AdminAiScanFinding from "./AdminAiScanFinding";
import AdminAiScanJsonDetails from "./AdminAiScanJsonDetails";
import AdminAiScanTreeSummary from "./AdminAiScanTreeSummary";
import { useState } from "react";

// Keep evidence with its feature group and mount findings only when that branch is opened.
const AdminAiScanFeatureGroup = ({
  group,
  hasReport,
  findingFields,
  expansion,
  severity,
}: AdminAiScanFeatureGroupProps) => {
  const [open, setOpen] = useState(expansion === "all");
  const findings = group.findings.filter((finding) => !severity || getAdminAiScanFindingSeverity(finding) === severity);
  const counts = getAdminAiScanSeverityCounts(findings);
  const status = getAdminAiScanText(group.review?.status, hasReport ? "STATUS_UNSPECIFIED" : "NOT_SCANNED");

  return (
    <details
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
      className={adminAiScansStyles.treeBranch}
      data-test="admin-ai-scan-feature-group"
    >
      <AdminAiScanTreeSummary
        label={group.label}
        id={group.id}
        meta={`${group.coverage} · ${status.replace(/_/g, " ")}`}
        counts={counts.length ? counts : [{ label: "Findings", value: 0 }]}
      />
      {open && (
        <div className="space-y-2 p-2 sm:p-3">
          {findings.map((finding, index) => (
            <AdminAiScanFinding
              key={`${getAdminAiScanText(finding.id)}:${index}`}
              finding={finding}
              findingFields={findingFields}
              expanded={expansion === "all"}
            />
          ))}
          {group.review && <AdminAiScanJsonDetails value={group.review} label="Feature review" />}
          {group.inventory && (
            <AdminAiScanJsonDetails value={group.inventory.behaviors ?? []} label="Behaviors and stable IDs" />
          )}
        </div>
      )}
    </details>
  );
};

export default AdminAiScanFeatureGroup;
